import React from 'react';
import { getUserProfileUrl } from '@adsk/acs-sc-web-platform-api';
import A from '@adsk/alloy-react-a';
import { Flex, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
export const MFATooltipContent = () => {
  const {
    T
  } = useLocale(_ref => {
    let {
      locale
    } = _ref;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    typography: "heading5"
  }, T.translate('MFA_REQUIRED')), /*#__PURE__*/React.createElement(Text, null, T.translate('TWO_STEPS_VERIFICATION_IS_REQUIRED_TO_ACCESS_THIS_PROJECT')), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: theme.spacing.medium,
      marginBottom: theme.spacing.small
    }
  }), /*#__PURE__*/React.createElement(A, {
    style: {
      color: theme.colors.adskBlue100
    },
    href: "".concat(getUserProfileUrl(), "/security"),
    onClick: e => e.stopPropagation()
  }, T.translate('SETUP_TWO_STEPS_VERIFICATION')));
};
//# sourceMappingURL=MFATooltipContent.js.map